import React, { useEffect, useState } from 'react';
import { fetchTipoPagamentos, saveTipoPagamento, deleteTipoPagamento } from './api/tipoPagamento';
import TipoPagamentoModal from './components/modals/TipoPagamentoModal';
import Layout from './components/Layout';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import Toolbar from './components/Toolbar';

const emptyForm = { codigo: '', descricao: '' };

export default function TiposPagamento() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selected, setSelected] = useState(null);
  const [atualizar, setAtualizar] = useState(false);

  useEffect(() => {
    fetchTipoPagamentos().then(setItems);
  }, [atualizar]);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  }

  function handleNew() {
    setForm(emptyForm);
    setIsEditing(false);
    setShowModal(true);
  }


  function handleEditSelected() {
    if (!selected) return;
    setForm(selected);
    setIsEditing(true);
    setShowModal(true);
  }

  function handleDeleteSelected() {
    if (!selected) return;
    if (window.confirm('Excluir tipo de pagamento?')) {
      deleteTipoPagamento(selected.codigo).then(() => {
        setAtualizar(a => !a);
        setSelected(null);
      });
    }
  }

  function handleSave(e) {
    e.preventDefault();
    saveTipoPagamento(form).then(() => {
      setShowModal(false);
      setAtualizar(a => !a);
    });
  }



  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="TIPOS DE PAGAMENTO" icon="bi-cash-coin" />
        <PageContent>
          <Toolbar onNew={handleNew} onEdit={handleEditSelected} disableEdit={!selected} onDelete={handleDeleteSelected} disableDelete={!selected} />
          <div className="table-responsive">
            <table className="table table-hover table-sm">
              <thead className="table-dark">
                <tr>
                  <th>Código</th>
                  <th>Descrição</th>
                </tr>
              </thead>
              <tbody>
                {items.map(item => (
                  <tr key={item.codigo}
                      className={selected && selected.codigo === item.codigo ? 'table-success' : ''}
                      onClick={() => setSelected(selected && selected.codigo === item.codigo ? null : item)}
                      style={{ cursor: 'pointer' }}>
                    <td>{item.codigo}</td>
                    <td>{item.descricao}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <TipoPagamentoModal show={showModal} onClose={() => setShowModal(false)} onSubmit={handleSave} form={form} handleChange={handleChange} isEditing={isEditing} />
        </PageContent>
      </ResponsiveShadow>
    </Layout>
  );
}
